<template>
  <div class="row">
    <div class="col-12">
      <div class="widget">
        <div class="widget-heading -list">
          <h1 class="textStyle">
            {{ $t("page.training_list") }}
            {{
              isFiltered
                ? "(" +
                  (maxResult ? maxResult : Object.keys(datas).length) +
                  " résultat" +
                  ((maxResult ? maxResult : Object.keys(datas).length) > 1 ? "s" : "") +
                  " filtré" +
                  ((maxResult ? maxResult : Object.keys(datas).length) ? "s" : "") +
                  ")"
                : ""
            }}
          </h1>
          <div>
            <button
              v-if="isFiltered"
              class="btn-icon me-1 btnReset"
              v-tooltip="{ title: $t('init_search') }"
              type="button"
              @click="resetSearch"
            >
              <FontAwesomeIcon icon="fa-light fa-arrows-rotate" />
            </button>
            <button
              class="btn-icon btnOpen"
              v-tooltip="{ title: $t('search_motor') }"
              type="button"
              @click="openSearch"
            >
              <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
            </button>
          </div>
        </div>
        <div class="widget-content">
          <SortTableComponent
            :actions="listActions"
            :apiFilters="true"
            :columns="columns"
            :datas="datas"
            :idKey="8"
            :loading="loading"
            :maxResult="maxResult"
            :isSearchAvailable="true"
            :defaultLimit="10"
            type="front-training"
            ref="sortTable"
            path="studeaManagerLayout"
            @refresh="refresh"
            @openSearch="openSearch"
            @showTriadList="showTriadList"
          />
        </div>
      </div>
    </div>
  </div>
  <ModalFormComponent :models="filterModels" :title="modalTitle" :storageKey="sessionStorageKey" @search="search" />
  <TriadListModalComponent :opened="triadListOpen" :trainingCourse="trainingCourse" @hidden="triadListModalHidden" />
</template>

<script>
import { trainingManager } from "@/services/training/training-manager";
import SortTableComponent from "@/components/table/sortTable/SortTableComponent.vue";
import { formManager } from "@/services/form/form-manager";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/main/main";
import ModalFormComponent from "@/components/form/ModalFormComponent.vue";
import { triadManager } from "@/services/triad/triad-manager";
import TriadListModalComponent from "@/components/triad/TriadListModalComponent.vue";

export default {
  name: "TrainingListView",
  components: {
    TriadListModalComponent,
    ModalFormComponent,
    SortTableComponent,
  },
  data() {
    return {
      trainings: {},
      columns: [],
      filterModels: [],
      modalTitle: "",
      loading: false,
      isFiltered: false,
      listParams: [],
      datas: [],
      isSearchOpen: false,
      sessionStorageKey: "studea-front-training",
      maxResult: 0,
      triadListOpen: false,
      groupListOpen: false,
      groupListLoading: false,
      groupListTitle: "",
      trainingCourse: {},
      trainingCourses: [],
      listActions: [
        {
          icon: "eye",
          type: "primary",
          actionType: "router",
          action: "TrainingDashboard",
          translation: this.$t("registration.dashboard.go_to"),
          cfaStyle: true,
          aliasId: "trainingId",
        },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.setParams();
      this.getDatas();
    },

    setParams() {
      if (!this.listParams || !Object.keys(this.listParams).length) {
        this.listParams = {
          search: "archive=0",
          sortByField: 0,
          sortOrder: "ASC",
          limit: 50,
          offset: 0,
        };
      }
    },

    search(params) {
      this.loading = true;
      this.$refs.sortTable.activePage = 1;
      this.listParams["offset"] = 0;
      this.listParams["search"] = params;
      this.getDatas();
      this.isFiltered = true;
    },

    refresh(params) {
      this.listParams = params;
      this.init();
    },

    getFilters() {
      this.filterModels = [];
      this.modalTitle = this.$tc("global.search.title", 2, {
        name: this.$tc("admin.training.title", 2).toLowerCase(),
      });
      trainingManager.form("training/search").then((data) => {
        this.filterModels = data;
      });
    },

    openSearch() {
      this.getFilters();
      this.isSearchOpen = true;
    },

    async showTriadList(payload) {
      this.loading = true;
      try {
        this.trainingCourse["crews"] = await triadManager.loadTriadList(payload.id, false);
        this.trainingCourse["id"] = payload.id;
        this.triadListOpen = true;
      } finally {
        this.loading = false;
      }
    },

    triadListModalHidden() {
      this.trainingCourse = {};
      this.triadListOpen = false;
    },

    resetSearch() {
      this.listParams = [];
      this.$refs.sortTable.activePage = 1;
      this.datas = [];
      this.columns = [];
      this.isFiltered = false;
      window.sessionStorage.removeItem(this.sessionStorageKey);
      this.init();
    },

    getDatas() {
      if (window.sessionStorage.getItem(this.sessionStorageKey)) {
        this.listParams["search"] = JSON.parse(window.sessionStorage.getItem(this.sessionStorageKey));
        this.isFiltered = true;
      }
      if (this.isFiltered) {
        this.listParams["search"] = formManager.getQuery(this.listParams["search"]);
      }
      trainingManager.list(this.listParams).then((data) => {
        this.columns = sortableTableManager.getEntriesColumns(data.columns, this.columns);
        if (this.columns && this.columns[5]) {
          this.columns[5].sortable = false;
        }
        this.datas = data.data;
        this.maxResult = data.count;
        this.loading = false;
        this.setAppLoading(false);
      });
    },

    ...mapActions(useMainStore, { setAppLoading: "setAppLoading" }),
  },
};
</script>

<style lang="scss" scoped>
.list {
  &__row {
    border-bottom: 1px dashed $m-color_6;
    padding: 8px 0;
  }

  &__group {
    display: flex;
    align-items: center;
  }

  &__group + &__group {
    margin-top: 10px;
  }
}
</style>
